import { reskinStyles } from 'core/components/theme/theme-variant';

export default (theme) => ({
  pledgesCard: {
    position: 'relative'
  },
  noData: {
    paddingTop: 30,
    paddingBottom: 30,
    backgroundColor: theme.colorPalette.orange_50_op_10,
    ...reskinStyles(theme, {
      backgroundColor: theme.colorPalette.beige_25,
      color: theme.colors.text_primary,
      borderRadius: theme.sizes.innerCorners
    })
  },
  root: {
    cursor: 'pointer',
    ...reskinStyles(theme, { cursor: 'default' }),
    height: 48,
    '&$hover:hover': {
      backgroundColor: theme.colorPalette.orange_50_op_10,
      ...reskinStyles(theme, { backgroundColor: theme.colorPalette.beige_50 })
    }
  },
  hover: {},
  hName: {
    color: theme.colorPalette.black
  }
});
